import {
  Box,
  Button,
  Form,
  FormField,
  Input,
} from '@cloudscape-design/components';
import React, { useState } from 'react';
import { Player } from '../../api';
import { Key } from '../../utils/keyCodes';

export interface PlayersFormProps {
  onPlayerCreated?: (player: Player) => void;
}

export const PlayersForm: React.FC<PlayersFormProps> = (props) => {
  const [playerName, setPlayerName] = useState<string>('');
  const [playerError, setPlayerError] = useState<string>('');

  const submit = () => {
    const newName = playerName.trim();
    if (newName === '') {
      setPlayerError('Name can not be empty');
      return;
    }

    setPlayerError('');
    setPlayerName('');
    props.onPlayerCreated?.({ name: newName });
  };
  return (
    <>
      <Box variant="h3">Create new player</Box>
      <Form
        actions={
          <Button
            iconName="add-plus"
            formAction="none"
            variant="primary"
            onClick={submit}
          >
            Add Player
          </Button>
        }
      >
        <FormField errorText={playerError}>
          <Input
            type="text"
            value={playerName}
            onKeyDown={(e) => {
              if (e.detail.keyCode === Key.Enter) {
                submit();
              }
            }}
            onChange={({ detail }) => {
              setPlayerName(detail.value);
            }}
          />
        </FormField>
      </Form>
    </>
  );
};
